// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./helpers/base.less
// module id = 4
// module chunks = 2